<div *ngIf="isLoading" class="svg-loader"></div>
<div *ngIf="!simulationRunStatus" class="svg-loader"></div>
<div class="largeModelContainer">
  <div class="">
    <a class="cancelBtn cancelBtnPosn" (click)="onCancelClick()">cancel</a>
  </div>
  <div class="modelTitle alignCenter heading2">
    Model Specification: Data Source
  </div>
  <div class="modelBody" *ngIf="!nextStep">
    <form #connectorSpecificationForm="ngForm" *ngIf="!isLoading">
      <div class="pl-4 pr-4" [ngClass]="{'readOnly' : readOnly}">
        <div class="form-group row no-overflow connectors-form-group">
          <div class="col-sm-12">
            <div class="row mb-2 mr-0">
              <div class="col-sm-3">
                <div class="row mb-2">
                  <div class="col-sm-12">
                    <span class="form-label"><strong>Model:</strong> {{modelData.modelUniqueId}}</span>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="d-flex table-container">
                    <div class="col-12">
                      <div class="example-container">
                        <div class="drag-drop-container-header">Variables</div>
                          <div cdkDropList
                               #inputParametersList="cdkDropList"
                               [cdkDropListData]="inputParameters"
                               [cdkDropListConnectedTo]="[variablesList]"
                               class="drag-drop-container-list"
                               (cdkDropListDropped)="drop($event)">
                            <div title="{{item.data.captionName}}" class="drag-drop-container-box" *ngFor="let item of inputParameters" cdkDrag>
                              {{item.data.captionName}}
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="connectorContainer">
                  <div class="drag-drop-container-header pairedHeader">Variables Name</div>
                  <div class="drag-drop-container-header pairedHeader">Data Source</div>
                  <div class="clear"></div>
                  <div class="connectorPairs">
                    <div class="connectorSrcContainer">
                      <div cdkDropList
                           #variablesList="cdkDropList"
                           [cdkDropListData]="modelVariablesList"
                           [cdkDropListConnectedTo]="[inputParametersList]"
                           class="drag-drop-container-list"
                           (cdkDropListDropped)="drop($event)">
                        <div title="{{item.data.captionName}}" class="drag-drop-container-box" *ngFor="let item of modelVariablesList" cdkDrag>
                          {{item.data.captionName}}
                          <button class="actionIcon pointer matIconLink" mat-icon-button><mat-icon>link</mat-icon></button>
                        </div>
                      </div>
                    </div>
                    <div class="connectorSrcContainer">
                      <div cdkDropList
                           #sinkVariablesList="cdkDropList"
                           [cdkDropListData]="srcConnVariablesList"
                           class="drag-drop-container-list"
                           [cdkDropListConnectedTo]="[srcInputParametersList]"
                           (cdkDropListDropped)="drop($event)">
                        <div class="drag-drop-container-box" *ngFor="let item of srcConnVariablesList ;let i = index" cdkDrag>
                          {{item.mappedParameterName}}
                          <button class="actionIcon pointer" (click)="deleteMapping(i)" matTooltip="Delete" mat-icon-button>
                            <mat-icon class="action-icon-delete"></mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="clear"></div>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group row mb-3">
                  <label for="dataSourceName" class="col-sm-5 mt-2"><strong>Data Source: </strong></label>
                  <div class="col-sm-7">
                    <select class="custom-select form-control" id="dataSourceSelected"
                            [(ngModel)]="dataSourceSelected"
                            name="dataSourceSelected"
                            (change)="getDataSourceParameters()"
                            tabindex="-1" [disabled]="readOnly">
                      <option *ngFor="let item of dataSource" [ngValue]="item">{{item.dataSourceName}}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row mb-3 position-relative">
                  <label for="frequncy" class="col-sm-5 mt-2"><strong>Frequency: </strong></label>
                  <div class="col-sm-7">
                    <input type="number" class="form-control" id="frequncy"
                           [(ngModel)]="frequncy"
                           name="name"
                           #name="ngModel"
                           tabindex="-1" [disabled]="readOnly">
                  </div>
                  <div class="freqMin"> Min</div>
                </div>
                <div class="form-group row mb-3">
                  <label for="parameters" class="col-sm-5 mt-2"><strong>Parameters: </strong></label>
                  <div class="col-sm-7">
                    <input type="text" class="form-control"
                           id="parameters"
                           name="parameters"
                           #parameters="ngModel"
                           [(ngModel)]="selectedParameter"
                           [typeahead]="parameterList"
                           [typeaheadOptionField]="'srcParameter'"
                           (typeaheadOnSelect)="onSelectParameter($event.item)"
                           [typeaheadOptionsLimit]="5"
                           autocomplete="off"
                           tabindex="-1" [disabled]="readOnly">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modelFooter">
        <button class="actionBtn" *ngIf="(inputParameters.length === 0)"
                (click)="executeModel()"  [disabled]="!(modelVariablesList.length === srcConnVariablesList.length)"><span>Simulate</span></button>
        <button class="actionBtn" *ngIf="inputParameters.length !== 0" (click)="executeModel()" [disabled]="!(modelVariablesList.length === srcConnVariablesList.length)">Next</button>
        <button *ngIf="(modelData.inputParameters.length === 0) && readOnly" type="button" class="actionBtn" (click)="onCancelClick()">Ok</button>
        <div class="clear"></div>
      </div>
    </form>
  </div>
  <div class="modelBody" *ngIf="nextStep">
    <form (ngSubmit)="onSubmit()" #f="ngForm" [formGroup]="myFormGroup" *ngIf="!isLoading">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-6">
            <h5 class="modal-title text-center">Input Parameters</h5>
          </div>
          <div class="col-sm-6">
            <h5 class="modal-title text-center">Output Parameters</h5>
          </div>
        </div>
      </div>
      <div class="row connectorSpec justify-content-md-center">
        <div class="col-sm-6 paramContainer">
          <div class="row">
            <div *ngFor="let form_elem of form_template" class="col-sm-12">
              <div [ngSwitch]="form_elem.type">
                <div *ngSwitchCase="'textBox'" class="form-group row">
                  <label title="{{form_elem.label}}" [for]="form_elem.label" class="col-sm-5 col-form-label">
                    {{form_elem.label}}
                  </label>
                  <div class="col-sm-5">
                    <input type="text" class="form-control" [id]="form_elem.label"
                           formControlName="{{form_elem.inputModel}}"
                           required>
                  </div>
                  <div class="col-sm-2 col-form-label">{{form_elem.uom}}</div>
                </div>
                <div *ngSwitchCase="'number'" class="form-group row">
                  <label title="{{form_elem.label}}" [for]="form_elem.label" class="col-sm-5 col-form-label">
                    {{form_elem.label}}
                  </label>
                  <div class="col-sm-5">
                    <input type="number" class="form-control" [id]="form_elem.label"
                           formControlName="{{form_elem.inputModel}}"
                           required />
                  </div>
                  <div class="col-sm-2 col-form-label">{{form_elem.uom}}</div>
                </div>
                <div *ngSwitchCase="'checkbox'" class="form-group row">
                  <label title="{{form_elem.label}}" [for]="form_elem.label" class="col-sm-5 col-form-label">
                    {{form_elem.label}}
                  </label>
                  <div class="col-sm-5">
                    <input type="checkbox" class="form-control" [id]="form_elem.label"
                           formControlName="{{form_elem.inputModel}}" required>
                  </div>
                  <div class="col-sm-2 col-form-label">{{form_elem.uom}}</div>
                </div>
              </div>
            </div>
            <div *ngFor="let linkedItem of modelVariablesList" class="col-sm-12">
              <div class="form-group row">
                <span title="{{linkedItem.data.captionName}}" class="col-sm-5 col-form-label">
                  {{linkedItem.data.captionName}}
                </span>
                <div class="col-sm-5">
                  <input type="text" class="form-control" disabled>
                </div>
                <div class="col-sm-2 matIconLink"><mat-icon>link</mat-icon></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 paramContainer">
          <div class="outputContiner">
            <table class="table" aria-labelledby ="DataSource" *ngIf="responseOutput.length > 0">
              <thead>
                <tr>
                  <th scope="col">Parameter Name</th>
                  <th scope="col">Value</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of responseOutput">
                  <td>{{item.key}}</td>
                  <td>{{item.value}}</td>
                </tr>
              </tbody>
            </table>
            <div class="invalid-entry" *ngIf="!responseOutput && errorOutpuMsg">{{errorOutpuMsg}}</div>
          </div>
        </div>
      </div>
      <div class="modelFooter">
        <button class="actionBtn mr-15" (click)="gotoPrev()">Previous</button>
        <button *ngIf="!readOnly" type="button" class="actionBtn mr-15" (click)="onSubmit()" [disabled]="!f.valid">
          <span>Simulate</span><span class="clearfix"></span>
        </button>
        <button *ngIf="readOnly" type="button" class="actionBtn" (click)="onCancelClick()">Close</button>
        <div class="clear"></div>
      </div>
    </form>
  </div>
</div>

